/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Gift_CardsInputs */

const en_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gift Cards Available`)
};

const es_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas de regalo disponibles`)
};

const de_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschenkkarten verfügbar`)
};

const zh_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用礼品卡`)
};

const ar_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطاقات هدايا متاحة`)
};

const fr_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartes-cadeaux disponibles`)
};

const vi_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thẻ quà tặng`)
};

const sw_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadi Za Zawadi Zinapatikana`)
};

const th_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีบัตรของขวัญ`)
};

const bs_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostupne poklon kartice`)
};

const ja_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ギフトカードあります`)
};

const ko_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기프트 카드 구매 가능`)
};

const pt_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartões-presente disponíveis`)
};

const it_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte regalo disponibili`)
};

const sv_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentkort tillgängliga`)
};

const nl_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadeaukaarten beschikbaar`)
};

const da_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gavekort tilgængelige`)
};

const nb_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gavekort tilgjengelige`)
};

const fi_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahjakortit saatavilla`)
};

const pl_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępne karty podarunkowe`)
};

const ru_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подарочные карты доступны`)
};

const tr_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hediye kartları mevcuttur`)
};

const hi_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिफ्ट कार्ड उपलब्ध`)
};

const id_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu Hadiah Tersedia`)
};

const ms_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad Hadiah Tersedia`)
};

const cs_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dárkové karty k dispozici`)
};

const el_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαθέσιμες δωροκάρτες`)
};

const he_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כרטיסי מתנה זמינים`)
};

const af_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geskenkkaarte beskikbaar`)
};

const hu_prices_gift_cards = /** @type {(inputs: Prices_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékkártyák kaphatók`)
};

/**
* | output |
* | --- |
* | "Gift Cards Available" |
*
* @param {Prices_Gift_CardsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_gift_cards = /** @type {((inputs?: Prices_Gift_CardsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Gift_CardsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_gift_cards(inputs)
	if (locale === "de") return de_prices_gift_cards(inputs)
	if (locale === "zh") return zh_prices_gift_cards(inputs)
	if (locale === "ar") return ar_prices_gift_cards(inputs)
	if (locale === "fr") return fr_prices_gift_cards(inputs)
	if (locale === "vi") return vi_prices_gift_cards(inputs)
	if (locale === "sw") return sw_prices_gift_cards(inputs)
	if (locale === "th") return th_prices_gift_cards(inputs)
	if (locale === "bs") return bs_prices_gift_cards(inputs)
	if (locale === "ja") return ja_prices_gift_cards(inputs)
	if (locale === "ko") return ko_prices_gift_cards(inputs)
	if (locale === "pt") return pt_prices_gift_cards(inputs)
	if (locale === "it") return it_prices_gift_cards(inputs)
	if (locale === "sv") return sv_prices_gift_cards(inputs)
	if (locale === "nl") return nl_prices_gift_cards(inputs)
	if (locale === "da") return da_prices_gift_cards(inputs)
	if (locale === "nb") return nb_prices_gift_cards(inputs)
	if (locale === "fi") return fi_prices_gift_cards(inputs)
	if (locale === "pl") return pl_prices_gift_cards(inputs)
	if (locale === "ru") return ru_prices_gift_cards(inputs)
	if (locale === "tr") return tr_prices_gift_cards(inputs)
	if (locale === "hi") return hi_prices_gift_cards(inputs)
	if (locale === "id") return id_prices_gift_cards(inputs)
	if (locale === "ms") return ms_prices_gift_cards(inputs)
	if (locale === "cs") return cs_prices_gift_cards(inputs)
	if (locale === "el") return el_prices_gift_cards(inputs)
	if (locale === "he") return he_prices_gift_cards(inputs)
	if (locale === "af") return af_prices_gift_cards(inputs)
	if (locale === "hu") return hu_prices_gift_cards(inputs)
	return en_prices_gift_cards(inputs)
});